var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailForbidLine = function SvgMailForbidLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.2 7.715-7.135 6.39L4.8 7.695V18.3h6.363c.09.624.273 1.231.544 1.8H3.9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9v7.43a6.3 6.3 0 0 0-1.8-.869zM18.75 5.7H5.26l6.795 5.996L18.752 5.7zm-2.514 14.138a2.7 2.7 0 0 0 3.601-3.601zm-1.273-1.274 3.6-3.6a2.7 2.7 0 0 0-3.6 3.601ZM17.4 21.9a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9"
  })));
};
export default SvgMailForbidLine;